const ConfigDB = {
  settings: {
    layout_type: "ltr",
    sidebar: {
      type: "compact-wrapper",
      iconType: "fill-icon",
    },
  },
  color: {
    primary_color: "#2A5699",
    secondary_color: "#EA6F4E",
    mix_background_layout: "light",
  },
};

export default ConfigDB;
